import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Box, ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import theme from './styles/theme';
import NotFound from './components/NotFound';
import ErrorFallback from './components/ErrorFallback';

const Article = React.lazy(() => import('./components/Article'));

Sentry.init({
  dsn: "https://615f9dfb7b8244ffb18e276b99713547@o1149705.ingest.sentry.io/4503944605532160",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider theme={theme}>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <Router>
            <Routes>
              <Route path="/" element={<App />} />
              <Route
                path="/articles/:slug"
                element={
                  <Suspense fallback={<Box minH="100vh" />}>
                    <Article />
                  </Suspense>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </Sentry.ErrorBoundary>
      </ChakraProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();